import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { Persistor, store } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import "./assets/styles/App.scss";
import "./translate";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={Persistor}>
          <App />
    </PersistGate>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();
